<template>
    <div class="main" :class="createClass()">
      <router-view />
    </div>
</template>

<script>

import { mapState, mapMutations } from 'vuex'
export default {
  name: 'App',
  data(){
    return{
      formalEnv:location.host.indexOf('cannews.com.cn') > -1 || location.host.indexOf('hkqg.hangkong.com.cn') > -1
    }
  },
 async beforeCreate() {
    const { list } = await this.$axios.post( this.$ApiInfo.getColumnList)
    list && list.length && (this.setColumnList(list));
    list.unshift({
      action_url: "getList",
      attribute: 0,
      channel: "首页",
      channel_id: this.formalEnv ? 10250 : 10217,
      isNewsWebHomePage: 1,
      type: '1'
    })
     list && list[0] && list[0].isNewsWebHomePage && (this.setIndexChannel(list[0]));

  },
  created() {
    document.title = "中国航空新闻网";
  },
  watch: {
    $route (val, oldVal) {
      if(val.path != oldVal.path) {
        this.setLoadingShow(true)
      }
    },
  },
  async mounted() {
    if(this.isPhone) {
      document.body && (document.body.style.background = 'none')
    }
    if(this.formalEnv){
      this.setRightModuleId({
        0: '17', //航空号
        1: '10247', //专题
        2: '10226', //热门视频
        3: '10219', //图集
        4: '', //英文频道 - 热门新闻   //新逻辑，改用当前频道的热门新闻
        5: '10219', //英文频道 - 图片
      })
    } else {
      this.setRightModuleId({
        0: 17, //航空号
        1: 10293, //专题
        2: 10290, //视频
        3: 10291, //图集
        4: '', //英文频道 - 热门新闻  //新逻辑，改用当前频道的热门新闻
        5: 10291, //英文频道 - 图片
      })
    }
    const {color_style} = await this.$axios.get( this.$ApiInfo.getInitSetting)
    if(color_style == 3){
      //飘灰
      document.body.style.filter = 'grayscale(100%)'
    }else if(color_style == 2){
      //飘红
      this.setIsRed(true)
    }
    if(this.isPhone) {
      document.body && (document.body.style.background = 'none')
    }
  },
  methods: {
    ...mapMutations(['setIndexChannel', 'setColumnList', 'setLoadingShow', 'setRightModuleId','setIsRed']),
    createClass(){
      let className = ''
      if(this.isPhone) className += 'wap-main'
      if(this.isRed) className += 'main-bg'
      return className
    }
  },
  computed: {
    ...mapState(['loadingShow','isRed']),
    isPhone() {
      return this.$Common.Attribute.isMb()
    }
  }
}
</script>

<style lang='less'>
.main-bg{
  background: url('./assets/img/pc/red_bg.png') no-repeat;
  // background-size: 100% auto;
  background-position-x: center;
}
.homeBg {
  background: linear-gradient(360deg, rgba(0, 109, 241, 0) 0%, rgba(0, 109, 241, 0.87) 79%, #006DF1 100%);
  background-size: 100% 37.75rem;
  background-repeat: no-repeat;
  &.channelBg {
    background: linear-gradient(#89e6ff,#89e6ff, #fff);
    background-size: 100% 37.75rem;
    background-repeat: no-repeat;
  }
}

.wap-main {
    width: 100%;
    overflow-y: scroll;
    .wap-wrapper {
        width: 100%;
    }
}
// label 1：专题，2：热点，3：图集，4：视频， 6:直播中， 7：直播回顾， 8：VR，9:活动， 10：广告， 11：本地， 12：置顶， 13：专栏， 14：精选，15：独家 16: 直播预告 17:原创

.label-text-large-1,.label-text-large-13,.label-text-large-6,.label-text-large-7,.label-text-large-16{
  position: relative;
  &::before{
    content: '';
    position: absolute;
    left: 12px;
    top: 12px;
    height: 30px;
    z-index: 2;
  }
}
.label-text-small-1,.label-text-small-13,.label-text-small-6,.label-text-small-7,.label-text-small-16{
  position: relative;
  &::before{
    content: '';
    position: absolute;
    left: 6px;
    top: 6px;
    height: 20px;
    z-index: 2;
  }
}
.label-title-text-small-1,.label-title-text-small-13, .label-title-text-small-6,.label-title-text-small-7,.label-title-text-small-16{
  position: relative;
  &::before{
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 16px;
    z-index: 2;
  }
}
.label-text-large-1{
  &::before{
    width: 72px;
    background: url('./assets/img/label_subject_large.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-text-large-red-1{
  &::before{
    width: 72px;
    background: url('./assets/img/label_subject_large_red.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-text-small-1{
  &::before{
    width: 48px;
    background: url('./assets/img/label_subject_small.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-text-small-red-1{
  &::before{
    width: 48px;
    background: url('./assets/img/label_subject_small_red.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-title-text-small-1{
  padding-left: 45px;
  &::before{
    width: 38px;
    background: url('./assets/img/label_subject_small.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-text-large-6{
  &::before{
    width: 77px;
    background: url('./assets/img/label_liveing_large.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-text-small-6{
  &::before{
    width: 51px;
    background: url('./assets/img/label_liveing_small.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-title-text-small-6{
  padding-left: 47px;
  &::before{
    width: 40px;
    background: url('./assets/img/label_liveing_small.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-text-large-7{
  &::before{
    width: 96px;
    background: url('./assets/img/label_playback_large.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-text-small-7{
  &::before{
    width: 64px;
    background: url('./assets/img/label_playback_small.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-title-text-small-7{
  padding-left: 58px;
  &::before{
    width: 51px;
    background: url('./assets/img/label_playback_small.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-text-large-13{
  &::before{
    width: 72px;
    background: url('./assets/img/label_column_large.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-text-large-red-13{
  &::before{
    width: 72px;
    background: url('./assets/img/label_column_large_red.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-text-small-13{
  &::before{
    width: 48px;
    background: url('./assets/img/label_column_small.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-text-small-red-13{
  &::before{
    width: 48px;
    background: url('./assets/img/label_column_small_red.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-title-text-small-13{
  padding-left: 45px;
  &::before{
    width: 38px;
    background: url('./assets/img/label_column_small.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-text-large-16{
  &::before{
    width: 96px;
    background: url('./assets/img/label_live_prophesy_large.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-text-small-16{
  &::before{
    width: 64px;
    background: url('./assets/img/label_live_prophesy_small.png') no-repeat;
    background-size: 100% 100%;
  }
}
.label-title-text-small-16{
  padding-left: 58px;
  &::before{
    width: 51px;
    background: url('./assets/img/label_live_prophesy_small.png') no-repeat;
    background-size: 100% 100%;
  }
}
</style>
